import React from "react";

import { Backdrop } from "@mui/material";
import { getloadingforfullscreen } from "../redux/slices/loadingSlice";
import { useAppSelector } from "../hooks/reduxhook";

const Loader = () => {
  const loading = useAppSelector(getloadingforfullscreen);

  return (
    <>
      <Backdrop
        sx={{ background: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={loading}
        aria-label="full-screen-loader"
      >
        <div id="loading-wrapper">
          <div id="loading-text">LOADING...</div>
          <div id="loading-content"></div>
        </div>
      </Backdrop>
    </>
  );
};

export default Loader;
